/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsLicenseCreateResponse
 */
export interface MelcoModelsLicenseCreateResponse {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsLicenseCreateResponse
     */
    melco_customer_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsLicenseCreateResponse
     */
    language?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsLicenseCreateResponse
     */
    email_address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsLicenseCreateResponse
     */
    serial_number?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsLicenseCreateResponse
     */
    product_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsLicenseCreateResponse
     */
    product_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsLicenseCreateResponse
     */
    product_level_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsLicenseCreateResponse
     */
    subscription_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsLicenseCreateResponse
     */
    referral_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsLicenseCreateResponse
     */
    batch?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MelcoModelsLicenseCreateResponse
     */
    cancelled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsLicenseCreateResponse
     */
    version_number?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsLicenseCreateResponse
     */
    version_id?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsLicenseCreateResponse
     */
    type?: number;
    /**
     * 
     * @type {Date}
     * @memberof MelcoModelsLicenseCreateResponse
     */
    created_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof MelcoModelsLicenseCreateResponse
     */
    updated_date?: Date | null;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsLicenseCreateResponse
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
}

export function MelcoModelsLicenseCreateResponseFromJSON(json: any): MelcoModelsLicenseCreateResponse {
    return MelcoModelsLicenseCreateResponseFromJSONTyped(json, false);
}

export function MelcoModelsLicenseCreateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsLicenseCreateResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'melco_customer_id': !exists(json, 'melco_customer_id') ? undefined : json['melco_customer_id'],
        'language': !exists(json, 'language') ? undefined : json['language'],
        'email_address': !exists(json, 'email_address') ? undefined : json['email_address'],
        'serial_number': !exists(json, 'serial_number') ? undefined : json['serial_number'],
        'product_code': !exists(json, 'product_code') ? undefined : json['product_code'],
        'product_name': !exists(json, 'product_name') ? undefined : json['product_name'],
        'product_level_name': !exists(json, 'product_level_name') ? undefined : json['product_level_name'],
        'subscription_code': !exists(json, 'subscription_code') ? undefined : json['subscription_code'],
        'referral_code': !exists(json, 'referral_code') ? undefined : json['referral_code'],
        'batch': !exists(json, 'batch') ? undefined : json['batch'],
        'cancelled': !exists(json, 'cancelled') ? undefined : json['cancelled'],
        'version_number': !exists(json, 'version_number') ? undefined : json['version_number'],
        'version_id': !exists(json, 'version_id') ? undefined : json['version_id'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'created_date': !exists(json, 'created_date') ? undefined : (new Date(json['created_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
    };
}

export function MelcoModelsLicenseCreateResponseToJSON(value?: MelcoModelsLicenseCreateResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'melco_customer_id': value.melco_customer_id,
        'language': value.language,
        'email_address': value.email_address,
        'serial_number': value.serial_number,
        'product_code': value.product_code,
        'product_name': value.product_name,
        'product_level_name': value.product_level_name,
        'subscription_code': value.subscription_code,
        'referral_code': value.referral_code,
        'batch': value.batch,
        'cancelled': value.cancelled,
        'version_number': value.version_number,
        'version_id': value.version_id,
        'type': value.type,
        'created_date': value.created_date === undefined ? undefined : (value.created_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
    };
}


